import { ResearchService } from "../../../../features/ResearchService";
import { ResearchPage } from "../../../../pages/ResearchPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const researchPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.research.root,
  element: <ResearchPage />,
  name: "Исследования",
  children: appRouterPaths.research.item
    ? [
        {
          path: appRouterPaths.research.item,
          element: <ResearchService />,
          name: "Исследование",
        },
      ]
    : undefined,
};
